export enum LanguageEnum {
  Korean = 'ko',
  English = 'en',
}

export interface ILocalizedStrings {
  sample1: string;
  sample2: (n: number) => string;
}

export interface ILocalizedBannerStrings {
  textContent: {
    id: string;
    mainText: string;
    subText: string;
    link: string;
  }[];
  buttonText: string;
}

export const LocalizedStrings: Record<LanguageEnum, ILocalizedStrings> = {
  [LanguageEnum.English]: {
    sample1: 'A revolutionary way to<br />register trademarks abroad',
    sample2: (n: number) => `${n}% discount will be applied automatically at checkout`,
  },
  [LanguageEnum.Korean]: {
    sample1: '클릭 몇 번으로 전세계에<br />간편하게 출원해보세요',
    sample2: (n: number) => `결제 시 ${n}% 할인 자동 적용`,
  },
};

export const LocalizedBannerStrings: Record<LanguageEnum, ILocalizedBannerStrings> = {
  [LanguageEnum.English]: {
    textContent: [
      {
        id: 'Global Customer Home Landing',
        mainText: 'Protect your brand worldwide with a few clicks!',
        subText: 'Guaranteed trademark registration available now',
        link: 'https://folio.marqvision.com/?utm_source=commerce',
      },
      {
        id: 'Global Customer File Landing',
        mainText: 'Supercharge your brand protection worldwide with just a click!',
        subText: 'Unlock guaranteed trademark registration',
        link: 'https://folio.marqvision.com/application/file/?utm_source=commerce',
      },
    ],
    buttonText: 'File an application',
  },
  [LanguageEnum.Korean]: {
    textContent: [
      {
        id: 'Korea Customer Home Landing',
        mainText: '전세계 브랜드 보호가 필요하신가요?',
        subText: '클릭 몇 번으로 간편하게 상표 출원해보세요',
        link: 'https://folio.marqvision.com/ko/?utm_source=commerce',
      },
      {
        id: 'Korea Customer File Landing',
        mainText: '상표 등록으로 더 강력하게 브랜드를 보호해보세요',
        subText: '업계 최저가와 거절 시 100% 환불을 보장드립니다',
        link: 'https://folio.marqvision.com/ko/application/file/?utm_source=commerce',
      },
    ],
    buttonText: '신청서 제출하기',
  },
};
